const ServiceCategoryCard = ({ title, image, short_description }) => {
    return (
        <div className="h-full bg-white border border-gray-100 p-6 md:p-8 rounded-2xl shadow-sm gh:shadow-xl gh:border-brand-500 transition-all duration-300 flex flex-col items-start space-y-4">
            {/* Icon Wrapper */}
            <div className="w-14 h-14 bg-gray-50 rounded-xl flex items-center justify-center gh:bg-brand-50 transition-colors">
                <img 
                    className="w-8 h-8 object-contain transition-transform duration-300 gh:scale-110" 
                    src={image} 
                    alt={title} 
                />
            </div>

            {/* Content */}
            <div className="space-y-2">
                <h3 className="Ethnocentric text-sm md:text-base text-gray-900 gh:text-brand-600 transition-colors uppercase tracking-tight">
                    {title}
                </h3>
                <p className="text-gray-500 text-xs md:text-sm leading-relaxed line-clamp-3">
                    {short_description}
                </p>
            </div>

            {/* Bottom Accent Line */}
            <div className="pt-4 mt-auto w-full">
                <div className="w-0 gh:w-full h-1 bg-brand-500 transition-all duration-500 rounded-full" />
            </div>
        </div>
    );
};

export default ServiceCategoryCard;